/**
 * CreateInviteForm Component
 *
 * Form for creating a new invite
 */
import ButtonSpinner from '../Loading/ButtonSpinner';
import styles from './CreateInviteForm.module.css';

function CreateInviteForm({ budgets, selectedBudget, setSelectedBudget, accessLevel, setAccessLevel, handleCreate, loading, error, onClose }) {
    return (
        <>
            {error && (
                <div className={styles.errorAlert}>
                    {error}
                </div>
            )}

            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Budget
                </label>
                <select
                    value={selectedBudget}
                    onChange={(e) => setSelectedBudget(e.target.value)}
                    className={styles.select}
                >
                    {budgets.map((budget) => (
                        <option key={budget.budgetKey} value={budget.budgetKey}>
                            {budget.budgetName}
                        </option>
                    ))}
                </select>
            </div>

            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Access Level
                </label>
                <select
                    value={accessLevel}
                    onChange={(e) => setAccessLevel(e.target.value)}
                    className={styles.select}
                >
                    <option value="member">Member (Transactions only)</option>
                    <option value="elevated_member">Elevated Member (Can edit template/categories)</option>
                </select>
            </div>

            <div className={styles.infoBox}>
                <strong>Note:</strong> Invite codes expire after 7 days and can only be used once.
            </div>

            <div className={styles.buttonContainer}>
                <button
                    onClick={onClose}
                    disabled={loading}
                    className={styles.cancelButton}
                >
                    Cancel
                </button>
                <button
                    onClick={handleCreate}
                    disabled={loading}
                    className={styles.submitButton}
                >
                    {loading && <ButtonSpinner />}
                    {loading ? 'Creating...' : 'Create Invite'}
                </button>
            </div>
        </>
    );
}

export default CreateInviteForm;
